module.exports = __webpack_public_path__ + "img/long-term-cache/logo_RA.511c3a4ca029198d96d41e078aafbee2.png";